import React from 'react';
import ContentLoader from 'react-content-loader';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from './keySection.module.scss';

export const KeySection = ({ className, loading, loaderWidth, ariaLabel, label }) => {
    const content = loading ? (
        <ContentLoader speed={2} height={10} width={loaderWidth} className={styles['placeholder']} />
    ) : (
        label
    );
    return (
        <div className={classnames(styles['label'], className)} aria-label={ariaLabel}>
            {content}
        </div>
    );
};

KeySection.propTypes = {
    className: PropTypes.string,
    loading: PropTypes.bool,
    loaderWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    testId: PropTypes.string,
    ariaLabel: PropTypes.string,
    label: PropTypes.string,
};

export default KeySection;
